import styled from "@emotion/styled";
import { Link, Outlet } from "@tanstack/react-router";
import { Flex, Text } from "styles/utility-components";

export default function NotificationsPage() {
  return (
    <PageContainer column alignItems="center">
      <HeaderContainer>
        <Text h2>Notifications</Text>
        <Text color="sysTextSecondary">
          Configure your notifications settings to decide what you want to be notified on.
        </Text>
      </HeaderContainer>
      <TabsContainer>
        <TabNav>
          <TabNavItem>
            <Link
              to="/account-management/notifications"
              activeOptions={{ exact: true }}
              activeProps={{ "data-active": "true" }}
            >
              Email notifications
            </Link>
          </TabNavItem>
          <TabNavItem>
            <Link
              to="/account-management/notifications/slack"
              activeProps={{ "data-active": "true" }}
            >
              Slack notifications
            </Link>
          </TabNavItem>
          <TabNavItem>
            <Link
              to="/account-management/notifications/teams"
              activeProps={{ "data-active": "true" }}
            >
              Teams notifications
            </Link>
          </TabNavItem>
        </TabNav>
        <Outlet />
      </TabsContainer>
    </PageContainer>
  );
}

const PageContainer = styled(Flex)(({ theme }) => ({
  backgroundColor: theme.colors.sysBackgroundDefault,
  width: "100%",
  height: "100%",
}));

const HeaderContainer = styled.div(({ theme }) => ({
  padding: 40,
  borderBottom: `1px solid ${theme.colors.sysBorderDecorative}`,
  width: "100%",
}));

const TabsContainer = styled.div({
  maxWidth: "960px",
  padding: "16px 48px",
  width: "100%",
});

const TabNav = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: 32,
  height: 48,
  borderBottom: `1px solid ${theme.colors.sysBorderDecorative}`,
  marginBottom: 24,
  position: "relative",
}));

const TabNavItem = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  height: "100%",
  position: "relative",
  minWidth: 85,
  justifyContent: "center",

  "& a": {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: "22px",
    color: theme.colors.sysTextSecondary,
    textDecoration: "none",
    cursor: "pointer",

    "&:hover": {
      color: theme.colors.sysPrimaryHover,
    },

    '&[data-active="true"]': {
      color: theme.colors.sysPrimaryDefault,
    },
  },

  '&:has(a[data-active="true"])::after': {
    content: '""',
    position: "absolute",
    bottom: -1,
    left: 0,
    right: 0,
    height: 2,
    backgroundColor: theme.colors.sysPrimaryDefault,
  },
}));
